import dayJs from "dayjs";
import constants from "../common/constants";

export default function setBasketRemainingTime(expiryDate: dayJs.Dayjs) {
  const remainingTime = expiryDate.diff(dayJs());
  const duration = dayJs.duration(remainingTime);
  const remainingTimeElements = document.querySelectorAll(
    constants.selectors.remainingTime
  );

  remainingTimeElements.forEach((remainingTimeElement) => {
    remainingTimeElement.textContent = duration.format("mm:ss");
  });

    const basketExpiryNotice = document.querySelector<HTMLElement>(constants.selectors.basketExpiryNotice);

    if (basketExpiryNotice) {
        basketExpiryNotice.style.opacity = "1";
    }
}
